import products from '../products';
import Product from './Product';
import { useBasketDispatchContext } from './Shop';

export default function ProductsList() {
  const basketDispatch = useBasketDispatchContext();
  return (
    <div className="products">
      {products.map((product) => (
        <Product key={product.id} {...product} />
      ))}
    </div>
  );
}
